import type { App } from 'vue'
import { type I18n, createI18n } from 'vue-i18n'

import messages from '@intlify/unplugin-vue-i18n/messages'

import { Locales } from '@/constants'
import { getLocale } from '@/services/localStorage'

export const i18n: I18n = createI18n({
  locale: getLocale() || Locales.EN,
  messages,
})

export function initI18n(app: App<Element>) {
  app.use(i18n)
}
